'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateDeclarationReference;

var _camelCaseProperty = require('css-in-js-utils/lib/camelCaseProperty');

var _camelCaseProperty2 = _interopRequireDefault(_camelCaseProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function generateDeclarationReference(property, value) {
  var pseudo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var media = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var support = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  return support + media + pseudo + (0, _camelCaseProperty2.default)(property) + value;
}